// extracted by mini-css-extract-plugin
module.exports = {"Added":"ChangeLogTable_Added__bDmO3","Remove":"ChangeLogTable_Remove__3SFJV","Updated":"ChangeLogTable_Updated__2Y0ce","NotFound":"ChangeLogTable_NotFound__2Vbuu"};